"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ResetPassword["default"];
  }
});
var _ResetPassword = _interopRequireDefault(require("./ResetPassword"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }